module.exports = __webpack_public_path__ + "media/images/allcare-academy-bg-ff89207dbbe36f8a6f088f3bd708a62a.jpg";